import Vue from 'vue'
import Router from 'vue-router'

import home from '@/components/home'
import develop from '@/components/develop'
import about from '@/components/about'
import login from '@/components/login'
import bannerdetail from '@/components/bannerdetail'
import plandetail from '@/components/plandetail'
import privacy from '@/components/privacy'
import legalNotices from '@/components/legalNotices'
import service from '@/components/service'
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

export default new Router({
  linkActiveClass: 'is-active',
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect:'/home'   
    },
    {
      path:'/home',
      name:'home',
      component:home
    },
    {
      path:'/home/bannerdetail/:id',
      name:'bannerdetail',
      component:bannerdetail
    },
    {
      path:'/home/plandetail/:id',
      name:'plandetail',
      component:plandetail
    },
     {
      path:'/home/legalNotices',
      name:'legalNotices',
      component:legalNotices
    },    
    {
      path:'/home/service',
      name:'service',
      component:service
    },
    {
      path:'/home/privacy',
      name:'privacy',
      component:privacy
    },
    {
      path:'/develop',
      name:'develop',
      component:develop
    },
    {
      path:'/about',
      name:'about',
      component:about
    },
    {
      path:'/login',
      name:'login',
      component:login
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js